import { useI18n } from '#hooks/useI18n';

export const useIdCardOptions = () => {
  const { t } = useI18n();
  return [
    { value: '', name: t('documentsModals.selectDocumentType') },
    { value: 'CIF', name: 'CIF' },
    { value: 'DNI', name: 'DNI' },
    { value: 'NIE', name: 'NIE' },
    { value: 'other', name: t('general.other') }
  ];
};


export const useIdCardOptionsForCompanies = () => {
  const options = useIdCardOptions();
  options.splice(1, 0, { value: 'CIF', name: 'CIF' });
  return options;
};
